import SinglePageHighlightsView from './SinglePageHighlightsView'


export default SinglePageHighlightsView
